/*
 * NgbDatepicker adapter
 *
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import {
  NgbDateAdapter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable ()
export class ReporterCustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel ( value: string | null ): NgbDateStruct | null {
    if ( value ) {
      if ( typeof value !== 'string' ) {
        return value;
      }
      const date = value.split ( this.DELIMITER );
      return {
        day: parseInt ( date[ 2 ], 10 ),
        month: parseInt ( date[ 1 ], 10 ),
        year: parseInt ( date[ 0 ], 10 )
      };
    }
    return null;
  }

  toModel ( date: NgbDateStruct | null ): string | null {
    return date ? date.year + this.DELIMITER + `${ date.month }`.padStart ( 2, '0' ) + this.DELIMITER + `${ date.day }`.padStart ( 2, '0' )
      : null;
  }
}
